import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import image1 from "url:../../public/res.png";
import image2 from "url:../../public/hotel.png";
import image3 from "url:../../public/health.png";
import image4 from "url:../../public/cons.png";
import image5 from "url:../../public/agriculture.png";
import image6 from "url:../../public/oil.png";
import image7 from "url:../../public/manufacturing.png";
import image8 from "url:../../public/retail.png";
import image9 from "url:../../public/realestate.png";
import image10 from "url:../../public/education.png";
import image11 from "url:../../public/media.png";
import image12 from "url:../../public/non-profit.png";
import "./Industries.css";

const industriesData = [
  {
    title: "Food and Beverage",
    description:
      "Our expertise in the Food & Beverage industry extends from navigating complex financial structures to providing strategic insights. We help businesses optimize financial performance and compliance while staying attuned to industry-specific challenges.",
    imageUrl: image1,
    icon: "🍽️",
    stats: { clients: "15+", experience: "10+ years" },
  },
  {
    title: "Hospitality and Tourism",
    description:
      "In the dynamic world of Hospitality & Tourism, we offer tailored financial solutions. From tax planning to risk management, our services empower clients to enhance operational efficiency and adapt to evolving market trends.",
    imageUrl: image2,
    icon: "🏨",
    stats: { clients: "12+", experience: "8+ years" },
  },
  {
    title: "Agriculture",
    description:
      "Partnering with the Agriculture sector, we assist in financial planning, risk mitigation, and sustainable growth. Our team understands the unique challenges of the industry, providing comprehensive support to farmers and agribusinesses.",
    imageUrl: image5,
    icon: "🌾",
    stats: { clients: "10+", experience: "12+ years" },
  },
  {
    title: "Oil and Gas",
    description:
      "Navigating the intricacies of the Oil & Gas sector, we offer financial and advisory services that align with industry demands. Our team is adept at addressing regulatory complexities and ensuring clients thrive in this ever-changing landscape.",
    imageUrl: image6,
    icon: "⛽",
    stats: { clients: "8+", experience: "15+ years" },
  },
  {
    title: "Construction",
    description:
      "From project financing to risk management, our services in the Construction industry foster growth and success. We collaborate with clients to optimize financial structures, enhance project efficiency, and navigate regulatory frameworks.",
    imageUrl: image4,
    icon: "🏗️",
    stats: { clients: "20+", experience: "14+ years" },
  },
  {
    title: "Manufacturing",
    description:
      "In the competitive Manufacturing landscape, we provide financial strategies that drive efficiency and innovation. Our tailored solutions support manufacturers in optimizing processes, managing costs, and staying ahead in a dynamic market.",
    imageUrl: image7,
    icon: "🏭",
    stats: { clients: "18+", experience: "11+ years" },
  },
  {
    title: "Retail",
    description:
      "Our comprehensive services in the Retail sector encompass financial management, inventory optimization, and strategic planning. We empower retailers to navigate market dynamics and achieve sustained success in a rapidly evolving industry.",
    imageUrl: image8,
    icon: "🛍️",
    stats: { clients: "25+", experience: "9+ years" },
  },
  {
    title: "Health Care",
    description:
      "Addressing the unique financial challenges of the Health Care sector, we offer solutions that enhance operational efficiency and compliance. Our services support healthcare providers in delivering quality care while maintaining financial stability.",
    imageUrl: image3,
    icon: "⚕️",
    stats: { clients: "14+", experience: "13+ years" },
  },
  {
    title: "Real Estate",
    description:
      "Partnering with the Real Estate industry, we provide financial guidance for property development, investment, and management. Our team helps clients navigate the complexities of real estate transactions and optimize returns.",
    imageUrl: image9,
    icon: "🏢",
    stats: { clients: "22+", experience: "16+ years" },
  },
  {
    title: "Education",
    description:
      " In the dynamic field of Education, we offer financial and strategic support. From budgeting to compliance, our services empower educational institutions to focus on their core mission while ensuring financial sustainability.",
    imageUrl: image10,
    icon: "🎓",
    stats: { clients: "16+", experience: "10+ years" },
  },
  {
    title: "Media and Advertising",
    description:
      "Our services in the Media & Advertising sector encompass financial planning, revenue optimization, and strategic positioning. We assist clients in navigating the dynamic landscape of media and advertising, ensuring financial success and market relevance.",
    imageUrl: image11,
    icon: "📺",
    stats: { clients: "11+", experience: "7+ years" },
  },
  {
    title: "Not-For-Profit Organizations",
    description:
      "Our audit, accounting, and consultancy services cater to non-profit organizations, focusing on financial transparency, compliance, and strategic financial management to support their mission-driven goals.",
    imageUrl: image12,
    icon: "🤝",
    stats: { clients: "13+", experience: "12+ years" },
  },
];

function Industries() {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredIndustries, setFilteredIndustries] = useState(industriesData);
  const [visibleCards, setVisibleCards] = useState([]);
  const [expandedCard, setExpandedCard] = useState(null);
  const [hoveredCard, setHoveredCard] = useState(null);
  const cardRefs = useRef([]);

  useEffect(() => {
    document.body.style.backgroundColor = "grey";
    return () => {
      document.body.style.backgroundColor = "";
    };
  }, []);

  useEffect(() => {
    const filtered = industriesData.filter((industry) =>
      industry.title.toLowerCase().includes(searchTerm.toLowerCase()),
    );
    setFilteredIndustries(filtered);
    setVisibleCards([]);
    setExpandedCard(null);
  }, [searchTerm]);

  useEffect(() => {
    const observers = [];

    cardRefs.current.forEach((card, index) => {
      if (!card) return;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              setTimeout(() => {
                setVisibleCards((prev) => [...new Set([...prev, index])]);
              }, 100);
              observer.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.2,
          rootMargin: "0px 0px -100px 0px",
        },
      );

      observer.observe(card);
      observers.push(observer);
    });

    return () => {
      observers.forEach((observer) => observer.disconnect());
    };
  }, [filteredIndustries]);

  const handleCardClick = (index) => {
    setExpandedCard(expandedCard === index ? null : index);
  };

  const clearSearch = () => {
    setSearchTerm("");
  };

  const handleGetInTouch = (e, industryTitle) => {
    e.stopPropagation(); // Prevent card from collapsing when clicking button
    navigate("/contact-information", { state: { industry: industryTitle } });
  };

  return (
    <div className="industries-container">
      <div className="industries-header">
        <h1 className="industries-title">Our Industries</h1>
        <p className="industries-subtitle">
          Specialized expertise across diverse sectors
        </p>
        <div className="stats-banner">
          <div className="stat-item">
            <span className="stat-number">{industriesData.length}</span>
            <span className="stat-label">Industries Served</span>
          </div>
          <div className="stat-divider"></div>
          <div className="stat-item">
            <span className="stat-number">60+</span>
            <span className="stat-label">Active Clients</span>
          </div>
          <div className="stat-divider"></div>
          <div className="stat-item">
            <span className="stat-number">16+</span>
            <span className="stat-label">Years Experience</span>
          </div>
        </div>
      </div>

      <div className="search-container">
        <div className="search-wrapper">
          <input
            type="text"
            placeholder="🔍 Search industries..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
          {searchTerm && (
            <button className="clear-search" onClick={clearSearch}>
              ✕
            </button>
          )}
        </div>
        {searchTerm && (
          <div className="search-results-info">
            Found {filteredIndustries.length}{" "}
            {filteredIndustries.length === 1 ? "industry" : "industries"}
          </div>
        )}
      </div>

      <div className="industries-list">
        {filteredIndustries.map((industry, index) => (
          <div
            ref={(el) => (cardRefs.current[index] = el)}
            className={`industry-item ${
              visibleCards.includes(index) ? "visible" : ""
            } ${index % 2 === 0 ? "slide-left" : "slide-right"} ${
              expandedCard === index ? "expanded" : ""
            } ${hoveredCard === index ? "hovered" : ""}`}
            key={index}
            onClick={() => handleCardClick(index)}
            onMouseEnter={() => setHoveredCard(index)}
            onMouseLeave={() => setHoveredCard(null)}
          >
            <div className="industry-content">
              <div className="industry-header-section">
                <div className="industry-icon-wrapper">
                  <span className="industry-icon">{industry.icon}</span>
                </div>
                <div className="industry-number">
                  {String(index + 1).padStart(2, "0")}
                </div>
              </div>
              <div className="industry-text">
                <h2 className="industry-title">
                  {industry.title}
                  <span className="expand-indicator">
                    {expandedCard === index ? "↑" : "↓"}
                  </span>
                </h2>
                <p className="industry-description">{industry.description}</p>

                <div
                  className={`industry-extra-info ${expandedCard === index ? "show" : ""}`}
                >
                  <div className="info-stats">
                    <div className="info-stat">
                      <span className="info-stat-value">
                        {industry.stats.clients}
                      </span>
                      <span className="info-stat-label">Clients</span>
                    </div>
                    <div className="info-stat">
                      <span className="info-stat-value">
                        {industry.stats.experience}
                      </span>
                      <span className="info-stat-label">Experience</span>
                    </div>
                  </div>
                  <button
                    className="contact-btn"
                    onClick={(e) => handleGetInTouch(e, industry.title)}
                  >
                    Get in Touch →
                  </button>
                </div>
              </div>
            </div>
            <div className="industry-image-wrapper">
              <img
                src={industry.imageUrl}
                alt={industry.title}
                className="industry-image"
              />
              <div className="image-overlay">
                <span className="overlay-text">Click to learn more</span>
              </div>
            </div>
          </div>
        ))}
      </div>

      {filteredIndustries.length === 0 && (
        <div className="no-results">
          <div className="no-results-icon">🔍</div>
          <h3>No industries found</h3>
          <p>Try adjusting your search terms</p>
          <button className="reset-btn" onClick={clearSearch}>
            Clear Search
          </button>
        </div>
      )}
    </div>
  );
}

export default Industries;
